import RecommendedAnswersCounts from 'models/recommended_answers_counts';
import createConverter from './lib/create_converter';

export default createConverter(RecommendedAnswersCounts);
